import { render } from "./SchnellkachelAuswahl.vue?vue&type=template&id=047591b0&scoped=true"
import script from "./SchnellkachelAuswahl.vue?vue&type=script&lang=js"
export * from "./SchnellkachelAuswahl.vue?vue&type=script&lang=js"

import "./SchnellkachelAuswahl.vue?vue&type=style&index=0&id=047591b0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-047591b0"]])

export default __exports__